<div class="login-page">
    <div class="login-spacer"></div>
    <div class="login-container" style="width: 23%">
        <img src="https://storage.googleapis.com/rxbc-pyxis-ui/content/img/rhsupportLogo2.png"
            width="410px" priority class="center">
        <h2 class="card-heading">
        </h2>
        <form class="login-form">
            <mat-form-field>
                <input matInput placeholder="Username">
            </mat-form-field>
            <mat-form-field>
                <mat-icon>user</mat-icon><input matInput type='password' placeholder="Password">
            </mat-form-field>
        </form>
        <div class="buttons">
            <div class="login">
                <button mat-raised-button color="primary">Login</button>
            </div>
        </div>
    </div>
</div>